import { useEffect } from 'react';
import { useAuthContext } from '@/contexts/use-auth-context';
import { FeatureFlag } from '@/enums/feature-flag';
import { rememberTenant } from '@/features/remembered-tenants/utils/remembered-tenants-storage';
import { useFeatureFlag } from '@/hooks/use-feature-flag';

export function useRememberSignedInTenant() {
  const { isAuthenticated, tenantSlug } = useAuthContext();
  const isEnabled = useFeatureFlag(FeatureFlag.REMEMBERED_TENANTS);
  const isSignedInTenant = isEnabled && isAuthenticated && tenantSlug !== null;

  useEffect(() => {
    if (isSignedInTenant) {
      rememberTenant(tenantSlug);
    }
  }, [isSignedInTenant, tenantSlug]);
}
